import styled from "styled-components";

export const TermsCardStyle = styled.div`
background-color: #001b48;
padding: 2.5rem;
color: #fff;
width: 25%;
min-height: 14.875rem;

& p{
	font-weight: 700;
	text-align: center;
	margin-top: 1.875rem;
}


@media(max-width:999px){
	width: 46%;
}

@media(max-width:631px){
	width: 100%;
	padding: 1.5rem;
	min-height: auto;
}
`